var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Vanta'),_c('v-row',{staticClass:"mt-5",attrs:{"justify":"center","align":"center","text":"center"}},[_c('p',{staticClass:"text-h3 welcome my-15"},[_vm._v("Welcome!!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }